





























































import { Component, Vue, Ref } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BRow, BCol, BButton, BIconPlus, BTooltip, BModal, BContainer, BCard, BCardBody, BIconDownload, BDropdown } from 'bootstrap-vue';
import DataTable from '@/components/DataTable.vue';
import PerformedWorkList from '@/components/PerformedWorkList.vue';
import PerformedWorkFilter from '@/components/PerformedWorkFilter.vue';
import PerformedWorkDetails from '@/components/PerformedWorkDetails.vue';
import PerformedWorkFilterOptions from '@/types/PerformedWorkFilterOptions';
import PerformedWorkListOptions from '@/types/PerformedWorkListOptions.vue';
import InlineSvg from 'vue-inline-svg';
import store from '@/store/index';
import Configuration from '@/types/Configuration';
import i18n from "@/i18n";
import { ExportFormatEnum } from '@/types/ExportFormatEnum';
import DateTime from '../types/DateTime';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'data-table': DataTable,
        'performedWork-list': PerformedWorkList,
        'performedWork-filter': PerformedWorkFilter,
        'performedWork-details': PerformedWorkDetails,
        'b-container': BContainer,
        'b-row': BRow,
        'b-col': BCol,
        'b-card': BCard,
        'b-card-body': BCardBody,
        'b-btn': BButton,
        'b-icon-plus': BIconPlus,
        'b-tooltip': BTooltip,
        'b-modal': BModal,
        'inline-svg': InlineSvg,
        'b-dropdown': BDropdown,
        'b-icon-download': BIconDownload
    }
})
export default class PerformedWorkView extends Vue {
    @Ref('pwExportDropdown') readonly pwExportDropdown!: BDropdown;
    @Ref('exportAsCsvBtn') readonly exportAsCsvBtn!: HTMLButtonElement;

    exportAs = ExportFormatEnum.Excel;
    performedWorkId: string | null = null;
    action: string | null = null;
    refreshList = false;
    isBusySave = false;
    exportSize = 0;
    filter: PerformedWorkFilterOptions | null = null;
    exportListOptions: PerformedWorkListOptions | null = null;

    mounted() {
        this.exportAsCsvBtn.classList.remove('btn', 'btn-secondary');
    }

    get performedWorkExportDownloadUrl() {
        return `${process.env.VUE_APP_BASE_API_URL}/performedwork/export`;
    }

    get apiAccessToken() {
        return store.state.apiAccessToken;
    }

    get authType() {
        return store.state.authType;
    }

    get language() {
        return i18n.locale;
    }

    get startDate() {
        const localStartDate = DateTime.toLocal(this.filter?.startDate as moment.Moment, DateTime.formats.date)?.startOf('day');
        return DateTime.toUtc(localStartDate, DateTime.formats.date)?.toISOString();
    }

    get endDate() {
        const localEndDate = DateTime.toLocal(this.filter?.endDate as moment.Moment, DateTime.formats.date)?.startOf('day');
        return DateTime.toUtc(localEndDate, DateTime.formats.date)?.toISOString();
    }

    onPerformedWorkOpened(id: string) {         
        this.performedWorkId = id;
        this.action = 'EDIT';
    }

    onPerformedWorkSelected(id: string) {         
        this.performedWorkId = id;
        this.action = 'COPY';
    }

    onLoadComplete(performedWorkCount: number) {
        this.exportSize = performedWorkCount;
        this.refreshList = false;
    }

    onPerformedWorkSaved(result: boolean) {          
        if (result) {
            this.refreshList = true;
        }
    }

    onPerformedWorkDeleted() {
        this.refreshList = true;
    }

    onFilterList(filter: PerformedWorkFilterOptions) {
        this.filter = filter;
        this.refreshList = true;
    }

    onListOptionsInitialized(listOptions: PerformedWorkListOptions) {
        this.exportListOptions = listOptions;
    }

    onExportAsCsvClick() {
        this.exportAs = ExportFormatEnum.CSV;
        this.pwExportDropdown.hide();
    }

    onExportAsExcelClick() {
        this.exportAs = ExportFormatEnum.Excel;
    }

    onSubmit(e: Event) {
        if (this.exportSize <= Configuration.MaxExportSize) {
            return true;
        }

        if (this.isBusySave) {
            return false;
        }
        this.isBusySave = true;

        this.$root.$bvToast.toast(this.$t('toaster.exportSizeError') as string, {
            title: this.$t('title') as string,
            autoHideDelay: Configuration.ToasterAutoHideDelay,
            appendToast: true,
            variant: Configuration.ToasterVariantError,
            toaster: Configuration.ToasterPosition
        });

        this.isBusySave = false;

        e.returnValue = false;
        e.preventDefault();
        return false;
    }
}
